






























































import { Vue, Component } from "../vue-ext";
import { Material, Account, Attachment, Role, HousingCompany, RoleEnum } from "../models";
import "../components/MaterialList";

@Component
export default class MaterialBankView extends Vue {
    private materials: Material[] = [];
    private account: Account | null = null;
    private housingCompany: HousingCompany | null = null;
    private search: string = "";
    private page: number = 1;
    private pageSize: number = 10;
    private lastPage: number = 1;
    RoleEnum = RoleEnum;

    private async created() {
        this.root.setTitle(this.$t("menu.materialBank") as string);
        this.root.setIconClass("icon-materials");

        this.housingCompany = this.root.getCurrentHousingCompany();
        this.account = this.root.getCurrentAccount() as Account;
        
        this.materials = this.root.materials; // this.root.getMaterials();

        this.lastPage = Math.ceil(this.materials.length / this.pageSize);
        this.page = 1;
    }

    private next() {
        if (this.page < this.lastPage) {
            this.page = this.page + 1;
        }
    }

    private previous() {
        if (this.page > 1) {
            this.page = this.page - 1;
        }
    }

    private filteredMaterials() {
        let filteredMaterials = this.search ? this.materials.filter(m => m.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) : this.materials;
        this.lastPage = Math.ceil(filteredMaterials.length / this.pageSize);

        if (this.page > this.lastPage) {
            this.page = this.lastPage;
        }
        
        return filteredMaterials.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    }
}
